module.exports = require("./daterangepicker.js");
require("./daterangepicker.css");


//////////////////
// WEBPACK FOOTER
// bootstrap-daterangepicker (bower component)
// module id = 503
// module chunks = 0